import { getConfigList } from '@src/api/aiAlerts';
import { useQuery } from 'react-query';
import { get } from 'lodash';
import { CONFIG_LIST_KEY } from './alertsQueryKey.constants';

export const useFetchConfigList = (enableRefetch) => {
  const { data, isFetching, isLoading } = useQuery(CONFIG_LIST_KEY,
    () => {
      return getConfigList().then((response) => get(response, ['data'], { aiAlertsConfig: [] }));
    },
    {
      retry: 3,
      refetchInterval: 5 * 60 * 1000, // 5m
      refetchOnWindowFocus: false,
      enabled: enableRefetch,
      onError: () => {
        throw new Error('AI alert config list fetch error');
      }
    },
  );

  return { data, isFetching, isLoading };
}
